module.exports = __webpack_public_path__ + "static/media/MyPlay_Logo.5b131dd7.svg";